module.exports = __webpack_public_path__ + "static/media/nav_cp_cap_bg.fd7b6685.png";